import { HttpParams } from '@angular/common/http';

// Builds the shared query params for the safety analytics endpoints
// (/jsa/analytics, /jsa/jsaTotals, /goodcatch/totals, /nearmiss/totals).
// An empty/undefined office list means "all offices" — no office param is sent.
export function buildAnalyticsParams(offices?: string[], startDate?: Date, endDate?: Date): HttpParams {
  let params = new HttpParams();
  (offices ?? []).forEach((office) => {
    params = params.append('office', office);
  });
  if (startDate) params = params.set('startDate', startDate.toISOString());
  if (endDate) params = params.set('endDate', endDate.toISOString());
  return params;
}
